<template>
	
	<div class="testbg">
		<div style="text-align: right;">
			<div class="block">
				<span class="demonstration"></span>
				<el-date-picker
				v-model="year"
				type="year"
				value-format="yyyy"
				@change="fetchData"
				placeholder="選擇年">
				</el-date-picker>
			</div>
		</div>
		<el-row class="mt-3" :gutter="20">
			<el-col v-for="(v,i) in head_list" :key="i" :span="6" :xs="24" class="mb-3">
				<el-card class="box-card"  shadow="hover">
					<router-link  style="text-decoration: none;" :to="{name:v.url}">
						<div class="new_head_nav" >
							<div class="new_head_nav_icon" :style="{'background-color':v.bg,'box-shadow':'0 3px 18px -8px '+v.bg}">
								<i  :class="v.icon"></i>
							</div>
							<div class="ml-3 new_head_right">
								<div class="new_info">{{v.title}}</div>
								<div class="new_head_num">{{v.total}}</div>
								
								<div class="new_info_div">
									<div class="new_info">{{v.info}}</div>
									<div v-if="v.info2" class="new_info">{{v.info2}}</div>
									<div v-if="v.info3" class="new_info">{{v.info3}}</div>
								</div>
								
							</div>
						</div>
					</router-link>
				</el-card>
			</el-col>
		</el-row>
		<div class="home_all" :class="this.layout.is_phone?'home_all_phone':''">
			
			<!-- 登錄明细 收支统计 -->
			<el-row :gutter="layout.index_p.gutter" class=" h_l" >
					<!-- 左边 -->
			
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>近30天數据统计</span>
							</div>
							
							<!-- 统计图容器 -->
							<div ref="myChart" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>

			</el-row>

			<!-- 14天订单金额统计 -->
			<el-row :gutter="layout.index_p.gutter" class=" h_l" >
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>近14天訂單金額統計</span>
							</div>
							
							<!-- 统计图容器 -->
							<div ref="myChartOrder14" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>
			</el-row>

			<!-- 14天比赛参加人数统计 -->
			<el-row :gutter="layout.index_p.gutter" class=" h_l" >
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>近14天比賽參加人數統計</span>
							</div>
							
							<!-- 统计图容器 -->
							<div ref="myChartCom14" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>
			</el-row>

			<!-- <el-row :gutter="layout.index_p.gutter" class=" h_l" >
					
					<el-col  :span="24" class="pb-4 h_200" >
						

						<el-card class="box-card h_200 new_card "  shadow="hover">
								<div slot="header" class="clearfix">
									<span>登錄日誌</span>
								</div>
								   <el-table
								   height="530"
								      :data="tableData" 
								      style="width: 100%;">
									  <el-table-column align="center" type="index" label="排序" width="50">
									  </el-table-column>
								      <el-table-column align="center"
								        prop="create_time"
								        label="登錄時間"
								        >
								      </el-table-column>
								      <el-table-column
								        prop="browse" align="center" 
								        label="瀏覽器"
								        >
								      </el-table-column>
									  
									  <el-table-column
									    prop="ip" width="150" align="center"
									    label="UP地址">
										</el-table-column>
									  <el-table-column
									    prop="sysversion"  align="center"
									    label="操作系統">
									  </el-table-column>
								
								    </el-table>
									
									<div class="mt-2" style="overflow-x: auto;">
										<el-pagination
										:current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
										 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
										</el-pagination>
									</div>
									
							</el-card>
					</el-col>
					
					
				
					
			</el-row> -->

			
			
			
			
			<!-- 登錄明细 收支统计 -->
			<!-- <el-row :gutter="layout.index_p.gutter" class=" h_l" >
			
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>近30天</span>
							</div>
							
							
							<div ref="myChart5" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>
					
					
				
					
			</el-row> -->
			
			
<!-- 			
			<el-row :gutter="layout.index_p.gutter" class="mt-3 h_l" >
					
			
					<el-col  :span="layout.index_p.span2" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>比賽占比</span>
							</div>
							
							
							<div ref="myChart3" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>
					
					
			
								
					<el-col  :span="layout.index_p.span2" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>练习占比</span>
							</div>
							
							
							<div ref="myChart4" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>
					
					
				
					
			</el-row> -->
			
			
			<el-row :gutter="layout.index_p.gutter" class=" h_1" >
					<!-- 左边 -->
			
					<!-- <el-col  :span="layout.index_p.span1" class=" h_100" > -->
						<el-card class="box-card h_100"  shadow="hover">
							<div slot="header" class="clearfix">
								<span>科目比賽佔比</span>
							</div>
							<div ref="myChart2" style="width: 100%;height: 270px;">
							</div>
						</el-card>
					<!-- </el-col> -->
					<!-- 右边 -->
					<!-- <el-col :span="layout.index_p.span2" class="pb-4 h_100" :class="this.layout.is_phone?'pb-4':''">
							<el-card class="box-card h_100 " shadow="hover" >
								<div slot="header" class="clearfix">
									<span>登錄日誌</span>
								</div>
								<el-table
								   	height="230"
								    :data="tableData" 
								    style="width: 100%;">
									<el-table-column align="center" width="180"
								        prop="username"
								        label="用戶名稱"
								        >
								      </el-table-column>
								      <el-table-column align="center" width="180"
								        prop="create_time"
								        label="登錄時間"
								        >
								      </el-table-column>
								      <el-table-column
								        prop="version" align="center" width="140"
								        label="登錄版本"
								        >
								      </el-table-column>
									  
									  <el-table-column
									    prop="ip" width="150" align="center"
									    label="IP地址">
										</el-table-column>
									  <el-table-column
									    prop="phone_type" width="200" align="center"
									    label="設備信息">
									  </el-table-column>
									  <el-table-column
									    prop="phone_info" width="200" align="center"
									    label="設備型號">
									  </el-table-column>
								
								    </el-table>
									
									<div class="mt-2" style="overflow-x: auto;">
										<el-pagination
										:current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
										 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
										</el-pagination>
									</div>
									
							</el-card>
							
						</el-col> -->
					
					
					
			</el-row>
			
					
			<div v-if="this.layout.is_phone">.</div>
			<div style="width: 100%;height: 80px;"></div>
		</div>
	
		
		
		
		
	
		

	
	
		
		
		

	
	
	<!-- 修改提现地址 -->
	
	<el-dialog :close-on-click-modal="false"  :title="edit_title" :visible.sync="createModel" top="5vh">
		<!-- 表單内容 -->
		<el-form :rules="rules" ref="form" :model="form" label-width="100px">
			<el-form-item label="提现地址" prop="url">
				<el-input v-model="form.url" placeholder="提现地址" clearable size="small" style="width: 50%;"></el-input>
			</el-form-item>
		</el-form>
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="createModel = false">取 消</el-button>
			<el-button type="primary" @click="submit">確 定</el-button>
		</div>
	</el-dialog>
	

	</div>
</template>

<script>
	//图形统计导入
	import common from '@/common/mixins/common.js';
	import echarts from 'echarts'
	import { mapState } from 'vuex';
	export default {
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				year:null,
				preUrl: "user/homeData", //列表地址
				tableData: [],
				shoplist: {},
				orderlist: {},
				counts: [],
				head_list:[],
				mtCheck:0,
				mtMoney:'',
				
				tableData:[],
				createModel:false,
				edit_title:'',
				addUrl: "user/editTxUrl", //修改提现地址
				form:{
					url:'',
					type:0
				},
				search:{
					date:''
				},
				
				rules: {
					url: [{
							required: true,
							message: "請輸入提现地址",
							trigger: 'blur',
						},
					
					]
				},
				
				order_list:[],
				sq_info:{
					'tk':{
						'status':0,
						'time':'',
						'url':''
					},
					'se':{
						'status':0,
						'time':'',
						'url':''
					},
					'la':{
						'status':0,
						'time':'',
						'url':''
					}
				}
			
			}
		},
		filters: {
			getCol(total) {
				return `col-${12/total}`
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		//dom渲染完毕 
		mounted() {
			//画统计图
			//this.drawLine()
		},
		methods: {
			async fetchData() {
				if (!this.year) return;
				try {
					this.search.date = this.year 
					this.getList()
				} catch (error) {
					console.error('查询接口出错:', error);
				}
			},
			updateHomeTime(){
				this.page.current = 1
				this.getList()
			},
		submit(type) {
				this.$refs.form.validate(res => {
					if (res) {
						this.addOrEdit(this.form)
						
					}
				})
				
				
			},
			getListResult(e) {
				this.page.total = e.total
				this.tableData = e.log_list
				if(this.page.current==1){
					this.order_list = e.order_list
					this.sq_info = e.sq_info
					this.head_list = e.head_list
					
				}
				
				
				this.$nextTick(() => {
					this.drawLine()
					this.drawLine2()
					this.drawLineOrder14()
					this.drawLineCom14()
				})

			},
			
			drawLine3() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart3);
				// 配置參數
			
				myChart.setOption(
					{
					 
					  tooltip: {
					    trigger: 'item'
					  },
					  legend: {
					    orient: 'vertical',
					    left: 'left'
					  },
					  series: [
					    {
					      name: '數量',
					      type: 'pie',
					      radius: '50%',
					      data: this.order_list.fb1,
					      emphasis: {
					        itemStyle: {
					          shadowBlur: 10,
					          shadowOffsetX: 0,
					          shadowColor: 'rgba(0, 0, 0, 0.5)'
					        }
					      }
					    }
					  ]
					}
				)
			},
			
					
			drawLine4() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart4);
				// 配置參數
			
				myChart.setOption(
					{
					 
					  tooltip: {
					    trigger: 'item'
					  },
					  legend: {
					    orient: 'vertical',
					    left: 'left'
					  },
					  series: [
					    {
					      name: '數量',
					      type: 'pie',
					      radius: '50%',
					      data: this.order_list.fb2,
					      emphasis: {
					        itemStyle: {
					          shadowBlur: 10,
					          shadowOffsetX: 0,
					          shadowColor: 'rgba(0, 0, 0, 0.5)'
					        }
					      }
					    }
					  ]
					}
				)
			},
			
			
			
			
			drawLine() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart);
				// 配置參數

				myChart.setOption(
					{
					
					  tooltip: {
					    trigger: 'axis'
					  },
					  legend: {
					    data: ['新增用戶', '自行註冊', '學校註冊']
					  },
					  grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					  toolbox: {
					    feature: {
							magicType: { show: true, type: ['line', 'bar'] },
							restore: { show: true },
					      saveAsImage: {}
					    }
					  },
					  xAxis: {
					    type: 'category',
					    boundaryGap: false,
					    data: this.order_list.day.date
					  },
					  yAxis: {
					    type: 'value'
					  },
					  series: [
						  {
						    name: '新增用戶',
						    type: 'line',
						    stack: '',
						    color:'#ffda4a',
						    data: this.order_list.day.first
						  },
					    
					    {
					      name: '自行註冊',
					      type: 'line',
					      stack: '',
						  color:'#6ad3a7',
					      data: this.order_list.day.order_1
					    },
						{
						  name: '學校註冊',
						  type: 'line',
						  stack: '',
						   color:'#ff888a',
						  data: this.order_list.day.order_2
						}
					    
					    
					  ]
					}
				)
			},
			
			drawLine5() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart5);
				// 配置參數
			
				myChart.setOption(
					{
					
					  tooltip: {
					    trigger: 'axis'
					  },
					  legend: {
					    data: ['總費用','入库空运','入库海运','上架費','退货上架','退仓','弃货','订單出库','仓储費']
					  },
					  grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					  toolbox: {
					    feature: {
							magicType: { show: true, type: ['line', 'bar'] },
							restore: { show: true },
					      saveAsImage: {}
					    }
					  },
					  xAxis: {
					    type: 'category',
					    boundaryGap: false,
					    data: this.order_list.day.date
					  },
					  yAxis: {
					    type: 'value'
					  },
					  series: [
						  {
						    name: '總費用',
						    type: 'line',
						    stack: '',
						    color:'#009ec7',
						    data: this.order_list.day.total
						  },
						  {
						    name: '入库空运',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_1
						  },
						  {
						    name: '入库海运',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_2
						  },
						  {
						    name: '上架費',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_3
						  },
						  {
						    name: '退货上架',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_4
						  },
						  {
						    name: '退仓',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_5
						  },
						  {
						    name: '弃货',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_6
						  },
						  {
						    name: '订單出库',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_7
						  },
						  {
						    name: '仓储費',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_8
						  },
						  					    
					    
					  
					    
					    
					  ]
					}
				)
			},
			
			drawLine2() {
				//初始化echarts实例 
				let myChart = echarts.init(this.$refs.myChart2);
				// 配置參數
				myChart.setOption(
					{
					  tooltip: {
					    trigger: 'item'
					  },
					  legend: {
					    orient: 'vertical',
					    left: 'left'
					  },
					  series: [
					    {
					      name: '數量',
					      type: 'pie',
					      radius: '50%',
					      data: this.order_list.com_subject,
					      emphasis: {
					        itemStyle: {
					          shadowBlur: 10,
					          shadowOffsetX: 0,
					          shadowColor: 'rgba(0, 0, 0, 0.5)'
					        }
					      }
					    }
					  ]
					}
				)
			},
			
			
			
			startLine(){
				console.log(startLine)
			},
			
			// 14天订单金额图表
			drawLineOrder14() {
				if (!this.$refs.myChartOrder14) {
					return;
				}
				if (!this.order_list || !this.order_list.day_order_14) {
					return;
				}
				
				// 销毁已有实例
				if (this.$refs.myChartOrder14._echarts_instance_) {
					echarts.getInstanceByDom(this.$refs.myChartOrder14).dispose();
				}
				
				let myChartOrder14 = echarts.init(this.$refs.myChartOrder14);
				const dateData = this.order_list.day_order_14.date || [];
				const moneyData = this.order_list.day_order_14.money || [];
				
				if (dateData.length === 0 || moneyData.length === 0) {
					return;
				}
				
				myChartOrder14.setOption(
					{
					
					  tooltip: {
					    trigger: 'axis'
					  },
					  legend: {
					    data: ['訂單金額']
					  },
					  grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					  toolbox: {
					    feature: {
							magicType: { show: true, type: ['line', 'bar'] },
							restore: { show: true },
					      saveAsImage: {}
					    }
					  },
					  xAxis: {
					    type: 'category',
					    boundaryGap: false,
					    data: dateData
					  },
					  yAxis: {
					    type: 'value'
					  },
					  series: [
						  {
						    name: '訂單金額',
						    type: 'line',
						    stack: '',
						    color:'#ffda4a',
						    data: moneyData
						  },
					    
					  ]
					}
				)
			},
			
			// 14天比赛参加人数图表
			drawLineCom14() {
				if (!this.$refs.myChartCom14) {
					return;
				}
				if (!this.order_list || !this.order_list.day_com_14) {
					return;
				}
				
				// 销毁已有实例
				if (this.$refs.myChartCom14._echarts_instance_) {
					echarts.getInstanceByDom(this.$refs.myChartCom14).dispose();
				}
				
				let myChart = echarts.init(this.$refs.myChartCom14);
				const dateData = this.order_list.day_com_14.date || [];
				const countData = this.order_list.day_com_14.count || [];
				
				if (dateData.length === 0 || countData.length === 0) {
					return;
				}
				
				myChart.setOption(
					{
					  tooltip: {
					    trigger: 'axis'
					  },
					  legend: {
					    data: ['參加人數']
					  },
					  grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					  toolbox: {
					    feature: {
							magicType: { show: true, type: ['line', 'bar'] },
							restore: { show: true },
					      saveAsImage: {}
					    }
					  },
					  xAxis: {
					    type: 'category',
					    boundaryGap: false,
					    data: dateData
					  },
					  yAxis: {
					    type: 'value'
					  },
					  series: [
						  {
						    name: '參加人數',
						    type: 'line',
						    stack: '',
						    color:'#6ad3a7',
						    data: countData
						  }
					  ]
					}
				)
			},
			
			
			
	
			//前往修改页面
			toView(name) {
				for (var i = 0; i < this.layout.navBar.list.length; i++) {
					
					let index = this.layout.navBar.list[i].submenu.findIndex(v => v.pathname == name);
					if(index!=-1){
						this.layout.navBar.active = i;
						// 跳转到當前激活
						this.layout.slideMenuActive = index
						break
					}
				}
				this.$router.push({
					name: name,

				})
			},
			// 打开模态框
			openModel(e, type) {
				// console.log(e)
				this.edit_title = '修改'+e.desc
				// 修改
				this.form = {
					url: e.num,
					type:e.o_type
				}
			
				// 打开dialog
				this.createModel = true
			}
		}
	}
</script>

<style>
	.index_btn{
		display: flex; align-items: center;justify-content: space-between;
	}
	.index_btn_left{
		background-color: #83d8ae;
		box-shadow: 0 3px 18px -8px #83d8ae;
		width: 45px;
		height: 45px;
		
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.index_btn_left2{
		background-color: #fc9494;
		box-shadow: 0 3px 18px -8px #fc9494;
	}
	.index_btn_left3{
		background-color: #3b8ff3;
		box-shadow: 0 3px 18px -8px #3b8ff3;
	}
	.index_btn_name{
		font-size: 20px;
	}
	.index_btn_info{
		font-size: 13px;color: #aaa;
	}
	
	.index_btn_ft28{
		font-size: 28px;
	}
	
	
	
	.new_home_p{
		font-size: 15px;
		font-weight: bolder;
		color: #333;
		margin-left: 10px;
	}
	.head_row .el-card__body{
		padding: 15px 10px;
	}
	

	.htr_main{
		display: flex;align-items:center;flex-direction: column;justify-content: center;
	}
	.htr_view{
		display: flex;align-items: center;
		justify-content: space-between;
		
		
		
		
		width: 100%;
	}
	.htr_top{
		border-radius: 5px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		
	}
	
	.htr_info{
		font-size: 14px;color: #92c0e9;
		
	}
	.htr_desc{
		color: #fff;font-size: 13px;
		text-align: right;
	}
	.htr_icon{
		width: 45px;height: 45px;color: #fff;
		background-color: #83d8ae;
		box-shadow: 0 3px 18px -8px #83d8ae;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.htr_icon i{
		font-size: 25px;
	}
	.htr_icon_red{
		background: #fc9494;
		box-shadow: 0 3px 18px -8px #fc9494;
	}
	
	
	
	.testbg{
		height: 100%;
	}
	.home_all{
		color: #fff;
		height: calc(100% - 130px);
		
	}
	
	.testbg .el-card__header{
		padding: 10px 20px;
		font-size: 15px;
	}
	.new_card .el-card__body{
		height: calc(100% - 44px);
	}
	.zj_card .el-card__body{
		height: 100%;
	}
	.h_100{
		height: 100%;
	}
	.h_50{
		height: 50%;
	}
	.h_l{
		height: auto;
	}
	.h_r{
		height: auto;
	}
	
	
	.home_all_phone .h_l,.home_all_phone .h_r{
		height: auto;
	}
	/* 新选项數据 */
	.new_head_nav{
		display: flex;align-items: center;
	}
	
	.new_head_nav_icon{
		width: 45px;
		height: 45px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		color: #fff;
		
	}
	
	.new_head_nav_icon i{
		font-size: 25px;
	}
	
	.new_info_div{
		display: flex;
		width: 100%;
		justify-content: space-between;
	}
	.new_head_right{
		flex: 1;
	}
	.new_info{
		color: grey;
		font-size: 13px;
	}
	
	.new_head_num{
		color: #222;
		font-size: 25px;
		margin: px 0;
	}
	
	
	/* 新选项數据 */
	
</style>
